const { fetchAuthorizedJsonApi } = require('./abstract');
const { apiUrls } = require('./apiUrls');

const fetchRecommendations = (token) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'GET',
    endpoint: 'matches/recommendations',
    expectedStatus: 200,
    description: 'Get recommendations',
  });

const superlikeRecommendation = (token, id) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: `matches/recommendations/${id}/superlike`,
    expectedStatus: 200,
    description: 'Superlike user recommendation',
  });

const likeRecommendation = (token, id) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: `matches/recommendations/${id}/like`,
    expectedStatus: 200,
    description: 'Like user recommendation',
  });

const dislikeRecommendation = (token, id, superLiked) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    body: { superLiked },
    endpoint: `matches/recommendations/${id}/dislike`,
    expectedStatus: 204,
    description: 'Dislike user recommendation',
  });

module.exports = {
  fetchRecommendations,
  superlikeRecommendation,
  likeRecommendation,
  dislikeRecommendation,
};
